import { animated } from '@react-spring/web';
import React, { FC, useEffect } from 'react';
import { createPortal } from 'react-dom';
import styled from '@xstyled/styled-components';
import { useFade } from '~/lib/transitions';
import { appTheme } from '~/shell/theme';
import { AnyStyledComponent } from 'styled-components';

const AnimatedDiv = animated.div as AnyStyledComponent;
const Styled = styled(AnimatedDiv)`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  perspective: 1000px;
  /* overflow: auto; */
  overflow: hidden;
  z-index: ${p => p.theme.zIndices.overlay};
`;

export const Overlay: FC<{
  open: boolean;
  onClick?: () => void;
  opacity?: number;
  dataTestId?: string;
}> = ({ open, onClick, children, opacity = 0.8, dataTestId }) => {
  const transition = useFade(
    open,
    'backgroundColor',
    appTheme.colors.overlayClear,
    appTheme.colors.overlayDark
  );

  const onKeyDown = (e: React.KeyboardEvent) => {
    const active = document?.activeElement;

    if (
      active?.previousElementSibling &&
      (e.key == 'ArrowLeft' || e.key == 'ArrowUp')
    ) {
      (active.previousElementSibling as HTMLElement).focus();
    }

    if (
      active?.nextElementSibling &&
      (e.key == 'ArrowRight' || e.key == 'ArrowDown')
    ) {
      (active.nextElementSibling as HTMLElement).focus();
    }
  };

  useEffect(() => {
    if (open) {
      const rootEl = document.getElementById('root');

      if (rootEl) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        rootEl.inert! = true;
      }
    }

    return () => {
      const rootEl = document.getElementById('root');
      if (rootEl) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        rootEl.inert! = false;
      }
    };
  }, [open]);

  if (!open) {
    return null;
  }

  return createPortal(
    <nav onKeyDown={onKeyDown}>
      {transition(
        (styles, item) =>
          item && (
            <Styled
              style={
                opacity
                  ? { ...styles, backgroundColor: `rgba(0, 0, 0, ${opacity})` }
                  : styles
              }
              onClick={onClick}
              data-test-id={dataTestId}
            >
              {children}
            </Styled>
          )
      )}
    </nav>,
    document.body
  );
};
